import { render, staticRenderFns } from "./MatterEdit.vue?vue&type=template&id=2a70198e&scoped=true&"
import script from "./MatterEdit.vue?vue&type=script&lang=ts&"
export * from "./MatterEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MatterEdit.vue?vue&type=style&index=0&id=2a70198e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70198e",
  null
  
)

export default component.exports